
export default {
  name: 'AgeDifferenceCalculator',
  data() {
    return {
      birthDate1: '',
      birthDate2: '',
      result: ''
    };
  },
  methods: {
    onAgeDifferenceCalculator() {
      if (this.birthDate1 && this.birthDate2) {

        const date1 = new Date(this.birthDate1);
        const date2 = new Date(this.birthDate2);

        const ageDiff = this.calculateYearMonthDayDiff(date1, date2);
        const age1 = this.calculateYearMonthDayDiff(date1, new Date());
        const age2 = this.calculateYearMonthDayDiff(date2, new Date());

        // Calculate the total difference in days, weeks, and years
        const diffTime = Math.abs(date2 - date1);
        const diffDaysTotal = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const diffWeeks = Math.floor(diffDaysTotal / 7);
        const diffDays = diffDaysTotal % 7;

        this.result = `Age difference: ${this.formatYearMonthDay(ageDiff)}\n` +
                      `Difference in weeks: ${diffWeeks} weeks and ${diffDays} days\n` +
                      `Difference in days: ${diffDaysTotal} days\n` +
                      `Age of person 1: ${this.formatYearMonthDay(age1)}\n` +
                      `Age of person 2: ${this.formatYearMonthDay(age2)}`;
      }
    },
    calculateYearMonthDayDiff(earlierDate, laterDate) {
      let years = laterDate.getFullYear() - earlierDate.getFullYear();
      let months = laterDate.getMonth() - earlierDate.getMonth();
      let days = laterDate.getDate() - earlierDate.getDate();

      // Adjust the days and months if necessary
      if (days < 0) {
        months--;
        const monthDays = new Date(laterDate.getFullYear(), laterDate.getMonth(), 0).getDate();
        days += monthDays;
      }

      if (months < 0) {
        years--;
        months += 12;
      }

      return { years, months, days };
    },
    formatYearMonthDay(age) {
      let formattedAge = [];
      if (age.years > 0) formattedAge.push(`${age.years} years`);
      if (age.months > 0) formattedAge.push(`${age.months} months`);
      if (age.days > 0) formattedAge.push(`${age.days} days`);
      
      return formattedAge.join(', ') || '0 days';
    },
    onSample() {
      this.birthDate1 = '1990-01-01';
      this.birthDate2 = '2024-01-01';
    },
    onReset() {
      this.birthDate1 = '';
      this.birthDate2 = '';
      this.result = '';
    }
  }

};

